import { cmsDataService } from '.'

export enum ConnectUrls {
    BookingUrl = '/RESTBooking.svc/booking',
    MarkCollected = '/RESTBooking.svc/booking/markcollected',
}

class ConnectService {
    POST = async <T>(url: ConnectUrls, model: any): Promise<T> => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + cmsDataService.get().api.authToken,
            },
            body: JSON.stringify(model),
        }
        const response = await fetch(cmsDataService.get().api.apiUrl + url, requestOptions)
        const data: T = await response.json()

        return data
    }

    // GET = async <T>(url: string): Promise<T> => {
    //     const requestOptions = {
    //         method: 'GET',
    //         headers: { Authorization: 'Bearer ' + cmsDataService.get().occApi.authToken },
    //     }
    //     const response = await fetch(cmsDataService.get().occApi.apiUrl +url)
    //     const data: T = await response.json()

    //     return data
    // }
}

export const connectService = new ConnectService()
